import React, { useContext, useState } from 'react';
import "./PolymatchResults.css";
import GuestNav from '../Navbars/GuestNav';
import Footer from "../Footer";
import { UserContext } from '../UserContext';
import presult1 from '../../assets/presult1.png';
import presult2 from '../../assets/presult2.png';
import polymatch from '../../assets/Polymatch.png';
import ptop1 from '../../assets/ptop1.png';
import ptop2 from '../../assets/ptop2.png';
import ptop3 from '../../assets/ptop3.png';
import pencil from '../../assets/pencil.png';

const defaultResults = {
  '4-6': [
    { rank: 1, name: 'Hammad Omer', parent: 'Omer', country: 'Pakistan', score: 69832, correct: 97, incorrect: 3 },
    { rank: 2, name: 'Ismail Farhan', parent: 'Shafiqu r Rehman', country: 'Saudi Arabia', score: 59832, correct: 60, incorrect: 40 },
    { rank: 3, name: 'Abeeha Sohail', parent: 'Sadia', country: 'Saudi Arabia', score: 59832, correct: 59, incorrect: 41 },
    { rank: 4, name: 'Maryam Hamad', parent: 'Tayyab Arshad', country: 'Afghanistan', score: 59832, correct: 57, incorrect: 43 },
    { rank: 5, name: 'Amna Ahmad', parent: 'Adnan akhtar kiani', country: 'Pakistan', score: 59832, correct: 54, incorrect: 46 },
    { rank: 6, name: 'Faiza', parent: 'Abdulahrahman', country: 'Pakistan', score: 59832, correct: 50, incorrect: 50 },
    { rank: 7, name: 'Ahmad Bilal', parent: 'Urooj Rameez', country: 'Afghanistan', score: 59832, correct: 30, incorrect: 70 },
    { rank: 8, name: 'Student 8', parent: 'Parent 8', country: 'Pakistan', score: 59832, correct: 25, incorrect: 75 },
  ],
  '7-10': [
    { rank: 1, name: 'Ali', parent: 'Sara', country: 'Pakistan', score: 59832, correct: 65, incorrect: 35 },
    { rank: 2, name: 'Fatima', parent: 'Ahmed', country: 'Afghanistan', score: 59832, correct: 62, incorrect: 38 },
    { rank: 3, name: 'Zain', parent: 'Khalid', country: 'Saudi Arabia', score: 59832, correct: 60, incorrect: 40 },
    { rank: 4, name: 'Hira', parent: 'Nadia', country: 'Pakistan', score: 59832, correct: 58, incorrect: 42 },
    { rank: 5, name: 'Omar', parent: 'Imran', country: 'Afghanistan', score: 59832, correct: 55, incorrect: 45 },
    { rank: 6, name: 'Ayesha', parent: 'Sami', country: 'Pakistan', score: 59832, correct: 52, incorrect: 48 },
    { rank: 7, name: 'Bilal', parent: 'Rashid', country: 'Afghanistan', score: 59832, correct: 35, incorrect: 65 },
    { rank: 8, name: 'Student 8', parent: 'Parent 8', country: 'Pakistan', score: 59832, correct: 20, incorrect: 80 },
  ],
  '11-15': [
    { rank: 1, name: 'Wahab Omer', parent: 'Omer', country: 'Pakistan', score: 79832, correct: 100, incorrect: 0 },
    { rank: 2, name: 'Sana', parent: 'Ali', country: 'Afghanistan', score: 59832, correct: 66, incorrect: 34 },
    { rank: 3, name: 'Usman', parent: 'Farah', country: 'Saudi Arabia', score: 59832, correct: 64, incorrect: 36 },
    { rank: 4, name: 'Iqra', parent: 'Noman', country: 'Pakistan', score: 59832, correct: 60, incorrect: 40 },
    { rank: 5, name: 'Adeel', parent: 'Sadia', country: 'Afghanistan', score: 59832, correct: 58, incorrect: 42 },
    { rank: 6, name: 'Rabia', parent: 'Imran', country: 'Pakistan', score: 59832, correct: 55, incorrect: 45 },
    { rank: 7, name: 'Tariq', parent: 'Rashid', country: 'Afghanistan', score: 59832, correct: 40, incorrect: 60 },
    { rank: 8, name: 'Student 8', parent: 'Parent 8', country: 'Pakistan', score: 59832, correct: 15, incorrect: 85 },
  ],
};

const rankImg = {
  1: ptop1,
  2: ptop2,
  3: ptop3,
};

const PolymatchResults = () => {
  const { setUserRole } = useContext(UserContext);
  const [selectedAge, setSelectedAge] = useState('4-6');

  const onLogin = (usertype) => {
    const userRole = usertype === 'Student' ? "Student" : 
                    usertype === 'Teacher' ? "Teacher" : 
                    usertype === 'Admin' ? "Admin" : "guest";
    setUserRole(userRole);
  };

  return (
    <>
      <GuestNav onLogin={onLogin} />
      
      {/* First Section - Gray Background */}
      <section className="results-hero-section">
        <div className="results-hero-content">
          <h1 className="results-hero-heading">
            <span className="congratulations-text">Congratulations to All</span><br />
            <span className="participants-text">Participants and Winners!</span>
          </h1>
          
          <p className="results-hero-paragraph">
            View the complete list of winners, toppers, and participants who showcased their knowledge and dedication during the PolyMatch 2025 – Global Islamic Knowledge Competition held on 14 March 2025. Details regarding certificates, awards distribution, and event highlights are available below.
          </p>
        </div>
        <div className="results-hero-images">
          <img src={presult1} alt="Result 1" className="presult1-image" />
          <img src={presult2} alt="Result 2" className="presult2-image" />
        </div>
      </section>

      {/* Second Section - White Background */}
      <section className="results-content-section">
        <div className="results-content-wrapper">
          <img src={polymatch} alt="Polymatch" className="polymatch-logo" />
          <h2 className="competition-heading">Global Islamic Knowledge Competition 2025</h2>

          {/* Age Group Selector */}
          <div className="age-group-selector">
            <button
              className={`age-btn${selectedAge === '4-6' ? ' selected' : ''}`}
              onClick={() => setSelectedAge('4-6')}
            >
              Age 4-6
            </button>
            <button
              className={`age-btn${selectedAge === '7-10' ? ' selected' : ''}`}
              onClick={() => setSelectedAge('7-10')}
            >
              Age 7-10
            </button>
            <button
              className={`age-btn${selectedAge === '11-15' ? ' selected' : ''}`}
              onClick={() => setSelectedAge('11-15')}
            >
              Age 11-15
            </button>
          </div>

          <div style={{ height: '96px' }} />
          <div className="results-table-container">
            <table className="results-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Parent Name</th>
                  <th>Country</th>
                  <th>Total Score</th>
                  <th>Correct Answers</th>
                  <th>Incorrect / Not Attempted Answers</th>
                </tr>
              </thead>
              <tbody>
                {defaultResults[selectedAge].map((item, idx) => (
                  <tr key={idx}>
                    <td style={{textAlign: 'center'}}>
                      {item.rank <= 3 ? (
                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4}}>
                          <img src={rankImg[item.rank]} alt={`top${item.rank}`} style={{width: 26.85, height: 39, marginRight: 0}} />
                        </span>
                      ) : (
                        item.rank.toString().padStart(2, '0')
                      )}
                    </td>
                    <td>{item.name}</td>
                    <td>{item.parent}</td>
                    <td>{item.country}</td>
                    <td>{item.score}</td>
                    <td>{item.correct}</td>
                    <td>{item.incorrect}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ height: '96px' }} />
          <div className="stay-tuned-wrapper">
            <h2 className="stay-tuned-heading">
              <img src={pencil} alt="pencil" className="stay-tuned-pencil" />
              STAY TUNED FOR MORE COMPETITIONS
            </h2>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PolymatchResults;
